<template>
    <div class="requirement-container">
        <div class="requirement-create-container">
        <div class="requirement-create-text">
            <h2>云企业顾问</h2>
            <p>为您一对一解决问题</p>
        </div>
        <a class="require-submit" @click="onShowDialog">提交需求</a>
        </div>
        <div class="relation-container">
        <h2><span>关联服务</span></h2>
        <div :class="['relation-service', index !== service.length - 1 ? 'last-service' : '']"
            v-for="(item, index) in service" :key="index"
            @click="jumpTo(item.link)"
            :data-track-value="'landRequire' + item.link"
            :data-track-name="'落地页导航栏' + item.title">
            <div class="relation-service-container">
            <img :src="item.img">
            <div class="relation-service-content">
                <p class="title">{{item.title}}</p>
                <p class="des">{{item.des}}</p>
                <p class="price">￥{{item.price}}起</p>
            </div>
            </div>
        </div>
        </div>
        <SubmitDialog :name="name" :type="type" v-if="showDialog" @close="onClose"/>
    </div>
</template>

<script>
import SubmitDialog from './SubmitDialog.vue';
import jizhang from '../assets/jizhang.png';
import beian from '../assets/beian.png';
import shangbiao from '../assets/shangbiao.png';

export default {
    props: ['name', 'type'],
    components: {
        SubmitDialog
    },
    data () {
        return {
        service: [
            {
                img: jizhang,
                title: '代理记账服务',
                des: '云代理记账，品质服务，安心代账',
                price: '1199',
                link: 'bookkeeping'
            },
            {
                img: beian,
                title: 'ICP许可证',
                des: '经营性网站必备资质，助力企业合法合规经营',
                price: '1200',
                link: 'bla'
            },
            {
                img: shangbiao,
                title: '商标服务',
                des: '为您提供更专业、更智能、更省心的商标服务',
                price: '270',
                link: 'tms'
            }
        ],
        showDialog: false
        }
    },
    mounted() {
        if (this.$route.query.from === 'require') {
            this.showDialog = true;
        }
    },
    methods: {
        jumpTo(link) {
            window.open('#/' + link);
        },
        onShowDialog() {
            this.showDialog = true;
        },
        onClose() {
            this.showDialog = false;
        }
    }
}
</script>

<style lang="less" scoped>
.requirement-container {
    width: 254px;
    position: absolute;
    right: 0;
    top: 0;
    .requirement-create-container {
        width: 100%;
        height: 110px;
        padding: 0 16px;
        background: url(../assets/requirement_bac.png) no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .require-submit {
        width: 70px;
        height: 25px;
        background: #fff;
        border-radius: 13px;
        font-size: 12px;
        text-align: center;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 25px;
        color: #2468F2;
        display: block;
        cursor: pointer;
    }
    .requirement-create-text {
        h2 {
            height: 25px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 25px;
            color: #FFFFFF;
            margin-bottom: 8px;
        }
        p {
            height: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #FFFFFF;
        }
    }
    .relation-container {
        height: 450px;
        background-color: #fff;
        margin-top: 16px;
        padding: 20px 10px 0;
        h2 {
            height: 25px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 25px;
            color: #191C3D;
            text-align: center;
            margin-bottom: 4px;
        span {
            display: inline-block;
            position: relative;
        }
        span:before {
            content: '';
            width: 56px;
            height: 3px;
            background: linear-gradient(270deg, #459BFF 0%, rgba(0, 108, 255, 0) 100%);
            border-radius: 2px;
            display: block;
            position: absolute;
            left: -64px;
            top: 10px;
        }
        span:after {
            content: '';
            width: 56px;
            height: 3px;
            background: linear-gradient(90deg, #459BFF 0%, rgba(0, 108, 255, 0) 100%);
            border-radius: 2px;
            display: block;
            position: absolute;
            right: -64px;
            top: 10px;
        }
        }
    }
    .line {
        height: 1px;
        background-color: #DDDDDD;
        margin: 16px 0;
    }
    .last-service {
        border-bottom: 1px dashed #DDD;
    }
    .relation-service {
        padding: 16px 0;
        .relation-service-container {
            display: flex;
            justify-content: flex-start;
            cursor: pointer;
        }
        .relation-service-container:hover {
            .title {
                color: #2468F2;
            }
        }
        img {
            width: 70px;
            height: 70px;
            margin-right: 5px;
        }
        .relation-service-content {
            .title {
                height: 22px;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 22px;
                color: #191C3D;
            }
            .des {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #191C3D;
                opacity: 0.6;
                margin-top: 8px;
            }
            .price {
                height: 20px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 20px;
                color: #EF2323;
                margin-top: 4px;
            }
        }
    }
}
</style>
